var _g, _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlWaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1602_221)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#0055FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 12L44 28L28 44L12 28L28 12Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 39,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#F88545"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5646 42.5575C42.4089 42.7132 42.1418 42.7605 41.9861 42.6048L41.3096 41.9284C41.1385 41.7573 40.8611 41.7573 40.69 41.9284L40.0136 42.6048C39.8579 42.7605 39.5907 42.7132 39.435 42.5575C38.9165 42.0389 38.0757 42.0389 37.5572 42.5575C37.0387 43.076 37.0387 43.9167 37.5572 44.4352C37.7129 44.5909 37.7603 44.8581 37.6046 45.0138L36.9281 45.6902C36.757 45.8613 36.757 46.1388 36.9281 46.3099L37.6046 46.9863C37.7603 47.142 38.0274 47.0946 38.1831 46.9389C38.7017 46.4204 39.5424 46.4204 40.0609 46.9389C40.5795 47.4575 40.5794 48.2982 40.0609 48.8167C39.9052 48.9724 39.8579 49.2396 40.0136 49.3953L40.69 50.0717C40.8611 50.2428 41.1385 50.2428 41.3096 50.0717L41.9861 49.3953C42.1418 49.2396 42.4089 49.2869 42.5646 49.4426C43.0832 49.9612 43.9239 49.9612 44.4424 49.4426C44.9609 48.9241 44.9609 48.0834 44.4424 47.5649C44.2867 47.4092 44.2393 47.142 44.395 46.9863L45.0715 46.3099C45.2426 46.1388 45.2426 45.8613 45.0715 45.6902L44.395 45.0138C44.2393 44.8581 44.2867 44.5909 44.4424 44.4352C44.9609 43.9167 44.9609 43.076 44.4424 42.5575C43.9239 42.0389 43.0832 42.0389 42.5646 42.5575Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1602_221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlWaves);
export default __webpack_public_path__ + "static/media/PL-WAVES.18363806728e4bcdc69f59561d45969b.svg";
export { ForwardRef as ReactComponent };